import { render } from "./Table.vue?vue&type=template&id=5fe60ef8"
import script from "./Table.vue?vue&type=script&setup=true&lang=js"
export * from "./Table.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Pages/Retours/Table/Table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5fe60ef8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5fe60ef8', __exports__)) {
    api.reload('5fe60ef8', __exports__)
  }
  
  module.hot.accept("./Table.vue?vue&type=template&id=5fe60ef8", () => {
    api.rerender('5fe60ef8', render)
  })

}


export default __exports__